import { render, staticRenderFns } from "./editPackage.vue?vue&type=template&id=6b545f4a&scoped=true&"
import script from "./editPackage.vue?vue&type=script&lang=js&"
export * from "./editPackage.vue?vue&type=script&lang=js&"
import style0 from "./editPackage.vue?vue&type=style&index=0&id=6b545f4a&scoped=true&lang=css&"
import style1 from "./editPackage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b545f4a",
  null
  
)

export default component.exports